__webpack_require__.p = "https://geotho.github.io/link-laugh-love/";